export default __webpack_public_path__ + "static/media/ClinicsProLogo.88438ae0.png";